import { render, staticRenderFns } from "./pop_image.vue?vue&type=template&id=063addd2&scoped=true"
import script from "./pop_image.vue?vue&type=script&lang=js"
export * from "./pop_image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063addd2",
  null
  
)

export default component.exports